import { ActionIcon, Button } from '@mantine/core';
import {
  IconDownload,
  IconExternalLink,
  IconFilePlus,
  IconInfoCircle,
  IconPin,
  IconPinFilled,
  IconPlus,
  IconTrash,
  IconX
} from '@tabler/icons-react';

import ActivateReportIcon from '@/assets/icons/ActivateReportIcon';
import ArchiveIcon from '@/assets/icons/ArchiveIcon';
import EditIcon from '@/assets/icons/EditIcon';
import { StickNoteIcon } from '@/assets/icons/StickNoteIcon';
import UnArchiveIcon from '@/assets/icons/UnArchiveIcon';
import UnStickNoteIcon from '@/assets/icons/UnStickNoteIcon';

const iconMap = {
  edit: <EditIcon />,
  info: <IconInfoCircle size={14} />,
  plus: <IconPlus size={14} />,
  close: <IconX size={14} />,
  trash: <IconTrash size={14} />,
  uploadFile: <IconFilePlus size={14} />,
  externalLink: <IconExternalLink size={14} />,
  pin: <IconPin size={16} />,
  pinned: <IconPinFilled color="#FFA200" size={16} />,
  download: <IconDownload size={14} />,
  activate: <ActivateReportIcon />,
  archive: <ArchiveIcon />,
  unArchive: <UnArchiveIcon />,
  UnstickNoteIcon: <UnStickNoteIcon />,
  StickNoteIcon: <StickNoteIcon />
};

type IconButtonProps = {
  icon: keyof typeof iconMap;
  onClick?: () => void;
  label?: string;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
};

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick = () => {},
  label,
  loading = false,
  disabled = false,
  className
}) => {
  const iconElement = iconMap[icon];

  if (!label) {
    return (
      <ActionIcon
        variant="subtle"
        onClick={onClick}
        disabled={disabled}
        className={className}
        loading={loading}>
        {iconElement}
      </ActionIcon>
    );
  }

  return (
    <Button
      leftSection={iconElement}
      className={className}
      size="compact-sm"
      variant="subtle"
      disabled={disabled}
      onClick={onClick}>
      {label}
    </Button>
  );
};

export default IconButton;
